import React from 'react';
import SendedFormIcon from '../SendedFormIcon';
import useTranslate from '../../customHooks/useTranslate';
import Card from '../../muiComponents/Card';

const SignUpStep5 = () => {
    return (
        <div className='step-content__container'>
            <Card className='sended-form__container'>
                <SendedFormIcon />
                <div className='flex-column gap-16'>
                    <h3 className='sended-form__title'>
                        {useTranslate('thanks')}
                    </h3>
                    <p>{useTranslate('check_your_spam_folder')}</p>
                    <p>
                        {`${useTranslate('contact_sign_up')}`}
                        <a href='mailto:support@fastpayhotels.com'>
                            {' '}
                            support@fastpayhotels.com
                        </a>
                    </p>
                </div>
            </Card>
        </div>
    );
};

export default SignUpStep5;
